module.exports = __webpack_public_path__ + "img/logo2.75f8b65f.png";